exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".card__Card-module___3YmjV {\n    padding: 24px 12px;\n    margin-top: 24px;\n}\n", ""]);

// Exports
exports.locals = {
	"card": "card__Card-module___3YmjV"
};